'use strict';
angular.module('resCenterPictureRouterModule', []).config([
    '$stateProvider',
    function($stateProvider) {
        $stateProvider.state('front.networksource.classifiedresource.picture.resource', {
            url: '/resource?typename&nodeid&nodename&medianame',
            views: {
                'networksource@front.networksource.classifiedresource.picture': {
                    templateUrl: './networkResource/classifiedResource/picture/picture_main_tpl.html',
                    controller: 'resCenPictureCtrl',
                },
            },
        });
    },
]);
